<!-- Internally linked item -->
<div
  *ngIf="app?.link"
  class="app__item"
  fxFlex
  fxLayout="column"
  fxLayoutAlign="space-apart start"
  [routerLink]="[app.link]"
  [class.app__item-disabled]="!app.enabled"
  [style.pointer-events]="app.enabled ? 'auto' : 'none'">
  <ng-container *ngTemplateOutlet="appItemTemplate; context: { app: app }"></ng-container>
</div>

<!-- Externally linked item -->
<a
  *ngIf="app && app.external_link"
  class="app__item"
  fxFlex
  fxLayout="column"
  fxLayoutAlign="space-apart start"
  [href]="app.external_link"
  target="_blank"
  [style.pointer-events]="app.enabled ? 'auto' : 'none'"
  [class.app__item-disabled]="!app.enabled">
  <ng-container *ngTemplateOutlet="appItemTemplate; context: { app: app }"></ng-container>
</a>

<!-- Action function -->
<div
  *ngIf="app?.actionFunction"
  class="app__item"
  fxFlex
  fxLayout="column"
  fxLayoutAlign="space-apart start"
  (click)="app.enabled && app.actionFunction ? onActionClick() : null"
  [class.app__item-disabled]="!app.enabled"
  [style.pointer-events]="app.enabled ? 'auto' : 'none'">
  <ng-container *ngTemplateOutlet="appItemTemplate; context: { app: app }"></ng-container>
</div>

<ng-template #appItemTemplate let-app="app">
  <div fxFlex style="padding: 16px" fxLayout fxLayoutGap="16px">
    <img fxHide.lt-md fxFlex="0 0 56px" height="56px" [src]="'/assets/images/apps/' + app.image_url" />
    <div class="app__item-right">
      <h3 fxLayoutAlign="start center" fxLayoutGap="8px">
        <img fxHide fxShow.lt-md fxFlex="0 0 32px" height="32px" [src]="'/assets/images/apps/' + app.image_url" />
        <span>{{ app.title }}</span>
        <span *ngIf="app.badge_text" class="badge">{{ app.badge_text }}</span>
      </h3>
      <span class="app__helper-text">{{ app.description }}</span>
    </div>
  </div>

  <div style="width: 100%" fxFlex fxLayout fxLayoutAlign="space-between center">
    <div *ngIf="app.categories?.length > 0" class="app__item-categories" fxLayout fxLayoutGap="6px">
      <div *ngFor="let category of app.categories" class="app__item-category">{{ category }}</div>
    </div>
    <div *ngIf="app.builtBy" [matTooltip]="'Built by ' + (app.builtBy | builtByLabel)">
      <sbnb-icon *ngIf="app.builtBy !== 'hospitable'" icon="handshake-circle" class="text-night-lighter"></sbnb-icon>
      <img
        *ngIf="app.builtBy === 'hospitable'"
        [src]="'/assets/iconography/smartbnb-badge.svg'"
        height="20"
        width="20" />
    </div>
  </div>

  <div *ngIf="app.connected" class="connected-icon">
    <sbnb-icon icon="check" class="text-grass-darker" matTooltip="Connected"></sbnb-icon>
  </div>
</ng-template>
